<template>
  <div class="configuracion">
    <div class="section">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <div class="card" card-background-color="green">
            <header class="card-header" type="is-primary">
              <p class="card-header-title">Configuración</p>
            </header>
            <div class="card-content">
              <FormulateForm
                v-model="formValues"
                @submit="grabar"
                invalid-message="Llene todos los campos adecuadamente"
              >
                <FormulateInput
                  type="text"
                  name="razonsocial"
                  label="Nombre punto alimentacion"
                  validation="required" />
                <FormulateInput type="text" label="Url post" />
                <FormulateInput
                  type="text"
                  name="ubicacion"
                  label="Ubicación"
                  validation="required" />
                <br />
                <FormulateInput
                  type="submit"
                  :disabled="isLoading"
                  :label="isLoading ? 'Cargando...' : 'Grabar'"
              /></FormulateForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Config",
  data() {
    return {
      servicios: [],
      formValues: {},
      initialvalues: {},
      isLoading: true,
    };
  },
  beforeMount: function () {
    this.formValues = JSON.parse(localStorage.getItem("formValue") || "{}");
    this.isLoading = false;
  },
  methods: {
    grabar: function () {
      localStorage.setItem("formValue", JSON.stringify(this.formValues));
    },
  },
};
</script>
